module.exports = __webpack_public_path__ + "static/feather-1-30cb8f71b0ea63bb005ff40b8a8593d7.png";